export default __webpack_public_path__ + "static/media/hero@3x.8833ab0d.png";